import React, { useRef, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useToast } from "../../core/contexts/toast";
import FiltroPI from "./filtro";
import { useAutenticação } from "../../core/contexts/auth";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
import SopProductionGrowthChart from "../SopProduction/SopProductionGrowthChart";
import SopInventoryGrowthChart from "../SopInventory/SopInventoryGrowthChart";
import { SopFinanceForecastChart } from "../SopFinance/SopFinanceForecastChart";
import { SopSalesSalesForecastChart } from "../SopSales/SopSalesSalesForecastChart";
import { FiltroSopSales, RepositorioSopSales } from "../../core/repositories/sopSalesRepositorio";
import { FiltroSopProduction } from "../../core/repositories/sopProductionRepositorio";
import { FiltroSopInventory } from "../../core/repositories/sopInventoryRepositorio";
import { ModeloSopSales } from "../../core/models/sopSales";
import SopSalesTable from "../SopSales/SopSalesTable";
import SopFinanceMarginChart from "../SopFinance/SopFinanceMarginChart";
import moment from "moment";
import { useModal } from "../../core/contexts/modalContexto";
moment.locale("en");
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

var contador: number = 0;

export default function SopPrincipal() {
  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()

  const [valor, setValor] = useState(0);
  const [filtro, setFiltro] = useState(new FiltroSopSales());

  const [permissaoEditar, setPermissaoEditar] = useState<boolean>(false)

  const [listaAtual, setListaAtual] = useState<ModeloSopSales[]>([])
  const [editou, setEditou] = useState(false)
  const [modalSimulation, setModalSimulation] = useState(false);
  const { mostrarModal } = useModal();

  React.useEffect(() => {


  }, []);

  async function limparTudo() {
    //abrir modal de confirmação
    try {
      const modalResultadoConfirmacao = await mostrarModal({
        titulo: "Clear All?",
        subTitulo: "Are you sure you want to clear everything?",
        acao: t("pages.Continuar")
      })
      if (modalResultadoConfirmacao) {
        filtro.cod_usuario = usuario?.cod_usuario
        await new RepositorioSopSales().soaSalesLimpaRegistros(filtro)
        mostrarToast({
          titulo: t("pages.Sucesso!"),
          mensagem: t("Limpar Tudo com sucesso!"),
          tipo: "success",
        });
        atualizarFiltro(new FiltroSopSales());
        filtrarDados(new FiltroSopSales());
      }

    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  React.useEffect(() => {
    // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
    const observer = new MutationObserver(atualizaTamanhoTabela);
    if (bodyRef.current) {
      observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
    }
    return () => {
      observer.disconnect();
    };
  });

  function diferentes(filtroP: FiltroSopSales) {
    return filtroP.dth_inicio != filtro.dth_inicio || filtroP.dth_fim != filtro.dth_fim || filtroP.cod_business_unit != filtro.cod_business_unit || filtroP.cod_region != filtro.cod_region || filtroP.cod_product_family != filtro.cod_product_family || filtroP.cod_product != filtro.cod_product || filtroP.value != filtro.value
  }

  async function fecharModalTabela() {
    setModalSimulation(false)
    if (editou) {
      setFiltro({ ...filtro });
    }
  }
  React.useEffect(() => {
    if (usuario && usuario.cod_usuario) {
      carregarDados(filtro, true)
    }
  }, [usuario]);

  async function carregarDados(filtroP: FiltroSopSales, forca = false) {
    try {
      if (forca || diferentes(filtroP)) {
        const _contador = contador++;
        if (_contador === contador - 1) {
          filtroP.cod_usuario = usuario?.cod_usuario
          const filtroCopia = { ...filtroP };
          filtroCopia.dth_inicio = new Date()
          filtroCopia.dth_fim = new Date()
          filtroCopia.dth_inicio.setMonth(filtroCopia.dth_inicio.getMonth() - 1)
          filtroCopia.dth_fim.setMonth(filtroCopia.dth_fim.getMonth() + 1)
          filtroCopia.dth_inicio.setDate(1)
          filtroCopia.dth_fim.setDate(1)
          filtroCopia.dth_inicio.setHours(0, 0, 0, 0)
          filtroCopia.dth_fim.setHours(0, 0, 0, 0)
          const resposta2 = await new RepositorioSopSales().getFilter(filtroCopia)
          setListaAtual(resposta2)
          // await carregarLista(filtro);
          // atualizarInterface();
        }
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(filtroP: FiltroSopSales) {
    if (diferentes(filtroP)) {
      setFiltro({ ...filtroP });
    }
  }
  async function filtrarDados(novoFiltro: FiltroSopSales) {
    novoFiltro.flg_aberto = false
    atualizarFiltro(novoFiltro)
  }

  function atualizarInterface() {
    setFiltro({ ...filtro });
    carregarDados(filtro, true);
  }

  return (
    <div className="SopHome" >
      <div className="px-2">
        <FiltroPI titulo={t("Home")} filtro={{ ...filtro }} atualizarFiltro={atualizarFiltro} permissaoEditar={permissaoEditar} filtrarDados={filtrarDados} onSimulation={() => { setModalSimulation(true); setEditou(false) }} />
      </div>

      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">
            <Card className="border-0 shadow-sm mb-2 overflow-auto px-2 ">

              {/* <SalesCard /> */}

              <Row className="mb-1">

                <Col md={6}>
                  <Card>
                    <SopSalesSalesForecastChart filtro={filtro} home={true} onChange={atualizarInterface} />
                  </Card>

                </Col>
                <Col md={6}>
                  <Card>
                    <SopProductionGrowthChart filtro={filtro as FiltroSopProduction} valor={valor} />
                  </Card>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md={6}>
                  <Card>
                    <SopInventoryGrowthChart filtro={filtro as FiltroSopInventory} valor={valor} />
                  </Card>
                </Col>

                <Col md={6}>
                  <Card>
                    <SopFinanceMarginChart filtro={filtro} home={true} />
                  </Card>
                </Col>

              </Row>


              {/* <Row className="mb-2">
                <Col md={6}>
                  <Card className="">
                    <Table striped bordered hover size="sm" responsive className="table-100">
                      <thead>
                        <tr>
                          <th>Unit</th>
                          <th className="text-end">Forecast</th>
                          <th className="text-end">Budget</th>
                          <th className="text-end" >Difference (%)</th>
                          <th className="text-end">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row, idx) => (
                          <tr key={idx}>
                            <td className="text-start">{row.unit}</td>
                            <td>{row.forecast}</td>
                            <td>{row.budget}</td>
                            <td className={row.status === 'positive' ? 'text-success' : 'text-danger'}>{row.diff}</td>
                            <td>{statusIcon(row.status)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card>
                </Col>
              </Row> */}

              {/* <div className="text-end">
        <Button variant="primary" onClick={exportPDF}>Export PDF</Button>
      </div> */}
              {/* <Gauge value={12}/> */}
              {/* <SopPrincipalKPICards2></SopPrincipalKPICards2> */}
              {/* <TrendLineChart data={[1, 2, 3, 4, 5, 6]} ></TrendLineChart> */}
              {usuario &&
              <div className="d-flex justify-content-end mb-2">
                <Button className="me-1 margin-top-24" variant="outline-primary" size="sm" onClick={limparTudo}              >
                  {t("Reset")}
                </Button>
              </div>
            }
            </Card>
            
          </div>

        </div>


      </div>
      {/* <div className="table-100" >
        <TabelaSazonalidade
          filtro={filtroNoContexto}
          aberto={filtro.flg_aberto}
        />
      </div> */}

      <Modal show={modalSimulation} onHide={fecharModalTabela} size="xl" centered>
        <Modal.Header closeButton onHide={fecharModalTabela}>
          <Modal.Title>Simulation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SopSalesTable lista={listaAtual} setLista={(lista) => { setListaAtual(lista), setEditou(true) }} simulation={true} activeTab={"home"} filtro={filtro} salvarValor={atualizarInterface} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={fecharModalTabela}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

